import axios from "axios";
import {API_BASE_URL} from "../../utils/constants";
import { apiError, apiSuccess, resetApiSuccess } from "../../actions/api.action";
import store from "../../store";
import qs from "qs";
import { refreshAuthToken } from "./tokenRefresh";


const axiosInstance = axios.create({
  baseURL: API_BASE_URL,
  headers:{
    "Content-type": "application/json"
  },
});


axiosInstance.defaults.paramsSerializer = (params) => {
  return qs.stringify(params.params, { indices: false, encode: false});
}

let isRefreshing = false;
let failedQueue = [];

const processQueue = (error, token = null) => {
  failedQueue.forEach(prom => {
    if (error) {
      prom.reject(error);
    } else {
      prom.resolve(token);
    }
  });
  
  failedQueue = [];
}


axiosInstance.interceptors.request.use(function (config) {

  const token = localStorage.getItem('token');

  if(token != null && config.baseURL.includes('/api')) {
    config.headers['Authorization'] = `Bearer ${token}`;
  }

  return config;
}, function (error) {
    // Do something with request error
    return Promise.reject(error);
})

// Add a response interceptor
axiosInstance.interceptors.response.use(function (response) {
    const method = response.config.method;
    const METHODS_FOR_SAVING = ["POST", "PUT", "PATCH", "DELETE"]
    if (METHODS_FOR_SAVING.includes(method?.toUpperCase() ?? "") && response.request.responseURL.includes('api/')) {
        store.dispatch(apiSuccess());
        setTimeout(function(){
            store.dispatch(resetApiSuccess());
        }, 2000);
    }
    return response;
}, async function (error) {
    const originalRequest = error.config;
    
    if (error.response?.status === 401 && !originalRequest._retry) {
        if (isRefreshing) {
            return new Promise((resolve, reject) => {
                failedQueue.push({ resolve, reject });
            }).then(token => {
                originalRequest.headers['Authorization'] = 'Bearer ' + token;
                return axiosInstance(originalRequest);
            }).catch(err => {
                return Promise.reject(err);
            });
        }

        console.log("Expired access token. Refreshing...")
        originalRequest._retry = true;
        isRefreshing = true;

        try {
            const newToken = await refreshAuthToken();
            originalRequest.headers['Authorization'] = 'Bearer ' + newToken;
            processQueue(null, newToken);
            return axiosInstance(originalRequest);
        } catch (refreshError) {
            processQueue(refreshError, null);
            localStorage.removeItem("token");
            localStorage.removeItem("refreshToken");
            localStorage.removeItem("profile");
            window.location.href = '/login';
            return Promise.reject(refreshError);
        } finally {
            isRefreshing = false;
        }
    }

    store.dispatch(apiError(error));
    return Promise.reject(error);
});

export default axiosInstance;


